import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card,
    CardGroup,
    Nav,
    NavItem,
    CardBody
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import Logo from "/public/site-assets/svg/logo-black.svg"
import ImpellamGroup from "/public/site-assets/svg/impellam-group.svg"
import React, {
    useRef,
    useEffect,
    useState
} from "react";
import { useRouter } from 'next/router';
import Sourceflow from '/public/sourceflow_logo.svg';
import SocialLinks from '/components/SocialLinks';
import FooterCopyrightNavigations from '../../.sourceflow/footer_copyright_navigations.json';
import FooterDocumentsNavigations from '../../.sourceflow/footer_documents_navigations.json';
import FooterNavigations from '../../.sourceflow/footer_navigations.json'
import imageMetaData from "../../.sourceflow/image_metadata.json";

export default function MainFooter({
    global,
    pathPrefix,
    customClass = "",
}) {
    const router = useRouter();

    return (
        <section className={`${styles.root} ${customClass} position-relative`}>
            <Container>
                <div className="pt-3">
                    <Link href="/">
                        <a className="logo d-block" aria-label="Carbon60 Logo" title="Carbon60">
                            {/* <Logo /> */}
                            <SourceFlowImage
                                src={`/site-assets/images/carbon60-vertage-white-logo.png`}
                                size="200x"
                                alt={`Carbon60`}
                                className="card-img rounded-0"
                                imagesMetaData={imageMetaData}
                                path={pathPrefix ? pathPrefix : (`${pathPrefix}.image`) }
                            />
                        </a>
                    </Link>
                    <Row className="mt-4">
                        <Col md={12}>
                            <Row className="justify-content-between">
                                <Col md={6} lg={2}>
                                    <div className="mb-4 navigations">
                                        <p className="mb-1"><a href={`${router.pathname.startsWith("/us") ? "/us" : ""}/contact-us`}>Get in Touch</a></p>
                                        {/*<p className="mb-0">*/}
                                        {/*    <Link href="tel:02-076541000">*/}
                                        {/*        <a>*/}
                                        {/*            {router.pathname.startsWith("/us") ? "+1 954.433.4100  " : "02-076541000"}*/}
                                        {/*        </a>*/}
                                        {/*    </Link>*/}
                                        {/*</p>*/}
                                        <p>
                                            <Link href="mailto:enquiries@carbon60global.com">
                                                <a className="email">
                                                    {router.pathname.startsWith("/us") ? "enquiries@carbon60global.com" : "enquiries@carbon60global.com"}
                                                </a>
                                            </Link>
                                        </p>
                                    </div>
                                    <SocialLinks
                                        customClass="social-links w-100 mb-5 d-flex align-items-end footer"
                                    />
                                </Col>
                                <Col md={6} lg={10}>
                                    <Row className="justify-content-between">
                                    {FooterNavigations.category_values
                                    .filter(post => !post.parent.id) // only top-level parents
                                    .map((parent, index) => (
                                        <Col md={4} lg={2} key={index}>
                                        <p className="mb-1">
                                            {parent?.new_tab ?
                                                <Link href={`${parent.link.en}`}>
                                                    <a className="text-decoration-none" rel="noopener noreferrer">
                                                        {parent.title.en}
                                                    </a>
                                                </Link> :
                                                <Link href={`${router.pathname.startsWith("/us") ? "/us" : ""}${parent.link?.en}`}>
                                                    <a className="text-decoration-none">
                                                        {parent.title.en}
                                                    </a>
                                                </Link>
                                            }
                                        </p>

                                        <ul className="list-unstyled navigations">
                                            {FooterNavigations.category_values
                                            .filter(child => child.parent.id === parent.id) // children of this parent
                                            .map((child, childIndex) => (
                                                <li key={childIndex}>
                                                {child?.new_tab ?
                                                    <Link href={`${child.link.en}`}>
                                                        <a className="text-decoration-none" rel="noopener noreferrer">
                                                            {child.title.en}
                                                        </a>
                                                    </Link> :
                                                    <Link href={`${router.pathname.startsWith("/us") ? "/us" : ""}${child.link?.en}`}>
                                                        <a className="text-decoration-none">
                                                            {child.title.en}
                                                        </a>
                                                    </Link>
                                                }
                                                </li>
                                            ))}
                                        </ul>
                                        </Col>
                                    ))}

                                    <Col md={4} lg={2}>
                                        <p className="mb-1">Documents</p>
                                        <ul className="list-unstyled navigations" >
                                            {FooterDocumentsNavigations.category_values.map((post, index) => (
                                                <li key={index}>
                                                    {post?.new_tab ?
                                                        <Link href={`${post.link.en}`}>
                                                            <a className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                                                                {post.title.en}
                                                            </a>
                                                        </Link> :
                                                        <Link href={`${router.pathname.startsWith("/us") ? "/us" : ""}${post.link?.en}`}>
                                                            <a className="text-decoration-none">
                                                                {post.title.en}
                                                            </a>
                                                        </Link>}
                                                </li>
                                            ))}
                                        </ul>
                                    </Col></Row>
                                </Col>
                                
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-start mt-4">
                    <span className="impellem-group d-flex align-items-end me-4">
                        <small>Part Of</small>
                        <Link href="https://www.vertage.com/">
                            <a target="_blank" rel="noopener noreferrer" title="Vertage" className="ms-1 impellam-logo">
                                {/* <ImpellamGroup /> */}
                                <SourceFlowImage
                                    src={`/site-assets/svg/vertage-logo-white.svg`}
                                    size="200x"
                                    alt={`Vertage`}
                                    className="card-img rounded-0"
                                    imagesMetaData={imageMetaData}
                                    path={pathPrefix ? (`${pathPrefix}_2a.image`) : (`${pathPrefix}_2b.image`) }
                                />
                            </a>
                        </Link>
                    </span>
                    <div className="my-4 my-md-0">
                        <div className="my-4 my-md-0 text-left">
                            <small>
                                © Carbon60, All rights reserved 2019 | Registered Address: First Floor, Mulberry House, Parkland Square, 750 Capability Green, Luton, LU1 3LU | Company Number: 2209742
                                <br />
                                Some content on this site contains public sector information licensed under the Open Government Licence v3.0
                            </small>
                        </div>
                        <ul className="d-flex flex-wrap align-items-center justify-content-center list-unstyled footer-navigations-2 mx-auto my-3 pt-3">
                            {FooterCopyrightNavigations.category_values.map((post, index) => (
                                <li className="me-md-3 mb-1 pe-2 pe-md-0" key={index}>
                                    {post.new_tab ?
                                        <Link href={`${post.link.en}`}>
                                            <a className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                                                <small>{post.title.en}</small>
                                            </a>
                                        </Link> :
                                        <Link href={`${router.pathname.startsWith("/us") ? "/us" : ""}${post.link?.en}`}>
                                            <a className="text-decoration-none">
                                                <small>{post.title.en}</small>
                                            </a>
                                        </Link>}

                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="text-nowrap d-flex align-items-end">
                        <p className="mb-0 me-3"><small>© {new Date().getFullYear()} Carbon60.</small></p>
                        <p className="mb-0 me-1"><small>Site by</small></p>
                        <Link href="https://www.sourceflow.co.uk/">
                            <a className="sourceflow" rel="noopener noreferrer" target="_blank" title="SourceFlow">
                                <Sourceflow />
                            </a>
                        </Link>
                    </div>
                </div>
            </Container>
        </section>
    )
}